import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import CategoryIcon from './CategoryIcon';
import useSound from '../hooks/useSound';

const TABS = [
 {path:'/',icon:'home',label:'Home'},
 {path:'/games',icon:'games',label:'Play'},
 {path:'/ebooks',icon:'books',label:'Read'},
 {path:'/coloring',icon:'coloring',label:'Create'},
 {path:'/explore',icon:'explore',label:'Explore'},
];

export default function MobileNav() {
  const location = useLocation();
  const { play, say } = useSound();

  if (/^\/ebooks\/.+/.test(location.pathname)) return null;
  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-sunshine/30 lg:hidden safe-area-bottom"
      data-testid="mobile-bottom-nav"
      aria-label="Quick navigation"
    >
      <div className="flex items-center justify-around h-16 max-w-lg mx-auto">
        {TABS.map(tab => {
          const active = tab.path === '/' ? location.pathname === '/' : location.pathname.startsWith(tab.path);
          if (/^\/ebooks\/.+/.test(location.pathname)) return null;
  return (
            <Link
              key={tab.path}
              to={tab.path}
              onClick={() => { play('tap'); say(tab.label); }}
              className={`flex flex-col items-center justify-center tap-target w-12 h-14 rounded-xl transition-all ${
                active ? 'scale-110' : 'opacity-75'
              }`}
              data-testid={`mobile-tab-${tab.label.toLowerCase()}`}
              aria-label={tab.label}
              aria-current={active ? 'page' : undefined}
            >
              <CategoryIcon name={tab.icon} size={26} label="" />
              <span className={`text-[10px] font-body font-bold mt-0.5 ${active ? 'text-accent-coral' : 'text-brown/75'}`}>
                {tab.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
